import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default () =>
  createStyles({
    actionsContainer: { display: 'flex', alignItems: 'center', gap: '8px' },
    centerFields: {
      fontSize: 12,
      maxWidth: 60,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      '& .MuiIconButton-root': {
        padding: 0,
      },
    },

    centerLongFields: {
      fontSize: 12,
      maxWidth: 75,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      '& .MuiIconButton-root': {
        padding: 0,
      },
    },
    centerSmallFields: {
      textAlign: 'center',
      fontSize: 12,
      justifyContent: 'center',
      maxWidth: 30,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      '& .MuiIconButton-root': {
        padding: 0,
      },
      '& .makeStyles-cellContent': {
        justifyContent: 'center',
      },
      '& div': {
        justifyContent: 'center',
      },
    },
    listGrid: {
      paddingLeft: 10,
    },
    searchContainer: { alignItems: 'center', justifyContent: 'space-between' },
    buttonsBase: {
      borderTop: `1px solid ${palette.borderGray}`,
      justifyContent: 'right',
      paddingTop: 10,
    },
    buttonsAlign: {
      justifyContent: 'flex-end',
      display: 'flex',
      paddingBottom: 5,
    },
    formUser: {
      '& .MuiOutlinedInput-root': {
        height: 45,
      },

      '& .MusiGrid-container': {
        alignItems: 'center',
      },
    },
    emailField: {
      maxWidth: 160,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    accessButton: {
      fontSize: 15,
      color: palette.blue,
    },
    centerAccess: {
      textAlign: 'center',
      fontSize: 12,

      '& .MuiIconButton-root': {
        padding: 0,
      },
    },
    cardsTitle: {
      fontSize: 14,
      color: palette.darkGray,
      marginBottom: 4,
      fontWeight: 550,
    },
    cardsTitleModal: {
      fontSize: 14,
      color: palette.darkGray,
      fontWeight: 550,
    },
    cardGrid: { marginTop: 6 },
    statusModalGrid: { marginBottom: 16 },
    dashboardButtonsHeader: {
      color: palette.blue,
      padding: '4px 8px!important',
      '&:hover': {
        backgroundColor: palette.superLightDeepBlue,
      },
    },
    dashboardButtonsHeaderConfig: {
      color: palette.blue,
      padding: '4px 8px!important',
      marginLeft: 16,
      '&:hover': {
        backgroundColor: palette.superLightDeepBlue,
      },
    },
    dashboardHeader: { marginTop: 16 },
    switchText: { fontSize: 12, fontWeight: 500, marginLeft: 2 },
    switchGrid: { alignItems: 'center', display: 'flex', marginRight: '8px' },
    switchGridContainer: { marginBottom: 16 },
    previewModal: { display: 'flex', justifyContent: 'center' },
    cardPreview: {
      margin: '6px 6px 16px 6px',
      borderRadius: 'var(--borderRadius, 4px)',
      border: `1px solid ${palette.grey300}`,
      background: '#FCFCFC',
      boxShadow: '0px 1px 30px 0px rgba(0, 0, 0, 0.05)',
      justifyContent: 'center',
      display: 'flex',
      width: 'max-content',
    },
    cardPreviewItem: {
      margin: 6,
      borderRadius: 'var(--borderRadius, 4px)',
      border: `1px solid ${palette.grey300}`,
      background: '#FCFCFC',
      boxShadow: '0px 1px 30px 0px rgba(0, 0, 0, 0.05)',
      padding: 8,
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'space-between',
    },
    closeIcon: {
      color: palette.red,
      fontSize: 20,
      cursor: 'pointer',
      marginRight: 2,
    },
    dragIcon: {
      color: palette.blue,
      fontSize: 20,
      cursor: 'grab',
      marginLeft: 2,
    },
    cardPreviewNoDash: {
      margin: '6px 6px 16px 6px',
      borderRadius: 'var(--borderRadius, 4px)',
      border: `1px solid ${palette.grey300}`,
      background: '#FCFCFC',
      boxShadow: '0px 1px 30px 0px rgba(0, 0, 0, 0.05)',
      justifyContent: 'center',
      display: 'flex',
      padding: 8,
      alignItems: 'center',
    },
    noDashIcon: {
      color: palette.grey600,
      fontSize: 18,
      marginRight: 4,
    },
    optionsModal: { display: 'flex', justifyContent: 'flex-end' },
    cleanIcon: { color: palette.red, fontSize: 26, cursor: 'pointer' },
    cleanButton: {
      color: palette.red,
      padding: '4px 8px!important',
      '&:hover': {
        backgroundColor: palette.superLightRed,
      },
    },
    cardSelector: {
      margin: 6,
      maxWidth: '32%',
      width: '32%',
      cursor: 'pointer',
      borderRadius: 'var(--borderRadius, 4px)',
      border: `1px solid ${palette.grey300}`,
      background: '#FCFCFC',
      boxShadow: '0px 1px 30px 0px rgba(0, 0, 0, 0.05)',
    },
    cardSelectorActive: {
      border: `1px solid ${palette.green}`,
      margin: 6,
      borderRadius: 4,
      maxWidth: '32%',
      width: '32%',
      backgroundColor: palette.lightGreen,
    },
    modalCardHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: 4,
    },
    checkIconModal: { fontSize: 20, color: palette.green },
    modalCardHeaderCollapse: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: 0,
    },
    checkboxCell: {
      padding: '0 0 0 8px',

      '& .MuiCheckbox-root': {
        padding: 0,
      },

      '& span > span > svg': { width: 15, height: 15 },
    },
    usersManagementButton: {
      border: `1px solid ${palette.blue}`,
      color: palette.blue,
      fontSize: 12,
    },
  });
